import React, {useContext} from 'react'
import {Collapse} from "@material-ui/core";
import FormTranslationContext from "context/FormTranslationContext";
import NoticeTextInput from "../../components/inputs/NoticeTextInput";
import NoticeCpvInput from "../../components/inputs/NoticeCpvInput";
import NoticeYesNoInput from "../../components/inputs/NoticeYesNoInput";
import NoticeGlossaryInput from "../../components/inputs/NoticeGlossaryInput";
import NoticeDateInput from "../../components/inputs/NoticeDateInput";
import NoticeNumericInput from "../../components/inputs/NoticeNumericInput";
import NoticeTypography from "../../components/inputs/NoticeTypography";
import getObjectValue from "libs/getObjectValue";
import GridBlock from "components/GridBlock";
import Button from "components/Button";
import ExposureNeg1Icon from "@material-ui/icons/ExposureNeg1";
import Tr from "translations/Translations";


function OrderObjectDivided(
    {
        id,
        formikProps,
        realizationType,
        index,
        removePart
    }) {

    const gId = (name) => id + "." + name;
    const gVal = (name, prefix = true, defaultVal = null) => getObjectValue(prefix ? gId(name) : name, formikProps.values, defaultVal);
    const editable = getObjectValue('_editable', formikProps.values, true);
    const passive = getObjectValue('_passive', formikProps.values, false);
    const onlyNotice = getObjectValue('_onlyNotice', formikProps.values, false);
    const updateNotice = getObjectValue('_updateNotice', formikProps.values, true);
    const {getDict} = useContext(FormTranslationContext)
    const includesOptions = gVal("includesOptions");
    const realizationPeriod = gVal("realizationPeriod");
    const orderType = gVal("form.orderObject.orderType", false, null)

    return (<>
        <GridBlock justify="space-evenly">
            <NoticeTypography formTrKey={id}>: {index + 1}</NoticeTypography>
            {(onlyNotice || passive) && <Button disabled={updateNotice || !editable} variant="outlined" Icon={ExposureNeg1Icon} onClick={() => removePart(index)}>{Tr("remove_part_x", {x: index + 1})}</Button>}
        </GridBlock>

        <NoticeNumericInput
            formikProps={formikProps}
            id={gId("dealingValue")}
        />
        <NoticeGlossaryInput
            id={gId("dealingValueCurrency")}
            formikProps={formikProps}
            items={getDict("SL.MO.043")}
        />

        <Collapse in={"1.1.3" === realizationType || "11.1.3" === realizationType}>
            <NoticeTextInput
                formikProps={formikProps}
                id={gId("purchaserNeedsDescription")}
                multiline
            />
        </Collapse>

        <Collapse in={"1.2" === realizationType || "11.2" === realizationType}>
            <NoticeTextInput
                formikProps={formikProps}
                id={gId("innovationProductNeed")}
                multiline
            />
        </Collapse>

        <Collapse in={"1.1.1" === realizationType || "1.1.2" === realizationType || "11.1.1" === realizationType || "11.1.2" === realizationType}>
            <NoticeTextInput
                formikProps={formikProps}
                id={gId("orderSubjectDescription")}
                multiline
            />
        </Collapse>

        <NoticeCpvInput
            formikProps={formikProps}
            id={gId("mainCpv")}
            required
        />

        <NoticeCpvInput
            formikProps={formikProps}
            id={gId("additionalCpv")}
            multiple
        />

        <NoticeYesNoInput
            formikProps={formikProps}
            id={gId("includesOptions")}
            required
        />

        <Collapse in={includesOptions === true}>
            <NoticeTextInput
                formikProps={formikProps}
                id={gId("includesOptionsInfo")}
                multiline
                required
            />
        </Collapse>

        <NoticeGlossaryInput
            formikProps={formikProps}
            id={gId("realizationPeriod")}
            items={getDict("ENUM.025")}
            required
        />

        <Collapse in={realizationPeriod === "DateFromTo"}>
            <NoticeDateInput
                formikProps={formikProps}
                id={gId("realizationPeriodDateFrom")}
                required
            />
        </Collapse>

        <Collapse
            in={realizationPeriod === "DateFromTo" || realizationPeriod === "DateTo"}>
            <NoticeDateInput
                formikProps={formikProps}
                id={gId("realizationPeriodDateTo")}
                required
            />
        </Collapse>

        <Collapse
            in={realizationPeriod === "NumberOfDays" || realizationPeriod === "NumberOfMonths"}>
            <NoticeNumericInput
                formikProps={formikProps}
                id={gId("realizationPeriodAmount")}
                required
            />
        </Collapse>

        <NoticeYesNoInput
            formikProps={formikProps}
            id={gId("planRenewals")}
            required
        />

        <Collapse in={gVal("planRenewals") === true}>
            <NoticeTextInput
                formikProps={formikProps}
                id={gId("planRenewalsInfo")}
                multiline
                required
            />
        </Collapse>

        <NoticeYesNoInput
            formikProps={formikProps}
            id={gId("planOtherOrderForCurrentSupplier")}
            required={orderType === 'Works' || orderType === 'Services'}
        />

        <Collapse in={gVal("planOtherOrderForCurrentSupplier") === true}>
            <NoticeTextInput
                formikProps={formikProps}
                id={gId("planOtherOrderForCurrentSupplierInfo")}
                multiline
                required
            />
        </Collapse>
    </>)
}

OrderObjectDivided.propTypes = {};

export default OrderObjectDivided;
